import jasperPic from "@/public/images/artists/jasper.png";
import { Artist } from "@/types/types";

export const jasper = {
  id: "126",
  name: "Jasper",
  image: jasperPic,
  description: `Jasper's voice has a resonant timbre with a blend of warmth and grit that captures the essence of modern country music, featuring a deep, gravelly tone that conveys authenticity and emotional depth. It exhibits a robust mid-range with slight roughness, contributing to a powerful and soulful delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjasper-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Country", "Folk", "Rock", "Indie", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Low",
      },
      specific: {
        low: 45,
        high: 65,
      },
    },
  },
} as const satisfies Artist;
